var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('use',{attrs:{"xlink:href":_vm.iconPath,"xmlns:xlink":"http://www.w3.org/1999/xlink"}})])}
var staticRenderFns = []

export { render, staticRenderFns }